export * from './route';
export * from './error';

import * as Firebase from './firebase';
import * as Helpers from './helpers';
import * as Storage from './storage';
import * as Parsers from './parsers';

export const Utils = { Helpers, Storage, Firebase, Parsers };
